"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReferralVoucher = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _react = require("react");
var _logger = require("../../logger");
var _utils = require("../../utils");
var _CheckboxToggler = require("./CheckboxToggler");
var _VoucherInfo = require("./VoucherInfo");
var _jsxRuntime = require("react/jsx-runtime");
const ContentWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));
const ReferralVoucher = ({
  'data-testid': testId,
  voucherUnit
}) => {
  const {
    isApplied,
    voucherCode
  } = voucherUnit;
  const toggleVoucher = (0, _react.useCallback)(async () => {
    if (isApplied) {
      try {
        await (0, _utils.removeVoucher)(voucherCode);
      } catch (error) {
        if (error instanceof Error) {
          _logger.mainLogger.error(error);
        }
      }
    } else {
      try {
        await (0, _utils.addVoucher)(voucherCode);
      } catch (error) {
        if (error instanceof Error) {
          _logger.mainLogger.error(error);
        }
      }
    }
  }, [isApplied, voucherCode]);
  const handleToggleVoucher = (0, _react.useCallback)(async () => {
    await toggleVoucher();
  }, [toggleVoucher]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.InfoBanner, {
    "data-testid": testId,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ContentWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_VoucherInfo.VoucherInfo, {
        ...voucherUnit
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxToggler.CheckboxToggler, {
        toggleVoucher: handleToggleVoucher,
        isChecked: isApplied
      })]
    })
  });
};
exports.ReferralVoucher = ReferralVoucher;